import CartBrowser from 'components/admin/Carts/CartBrowser.jsx'
import CustomerCartDetails from 'components/admin/Carts/CustomerCart/CustomerCartDetails.jsx'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { cancelConfirm } from 'redux/navigation'
import { loadProducts } from 'redux/product'
import { loadUsers } from 'redux/userAdmin'
import { Grid } from 'semantic-ui-react'
import { loadCustomerOrders } from '../../redux/carts'

const mapStateToProps = undefined

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      cancelConfirm,
      loadCustomerOrders,
      loadUsers,
      loadProducts,
    },
    dispatch
  )
}

class OrderRequests extends React.Component {
  componentWillMount() {
    const { loadCustomerOrders, loadUsers, loadProducts } = this.props
    loadCustomerOrders(true)
    loadUsers()
    loadProducts()
  }

  render() {
    return (
      <Grid columns={2}>
        <Grid.Row>
          <Grid.Column
            mobile={12}
            tablet={12}
            computer={12}
            largeScreen={4}
            widescreen={4}
            className="stacked top up-to-computer">
            <CartBrowser kind="customer_orders" />
          </Grid.Column>
          <Grid.Column
            mobile={12}
            tablet={12}
            computer={12}
            largeScreen={8}
            widescreen={8}>
            <CustomerCartDetails />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

OrderRequests = connect(mapStateToProps, mapDispatchToProps)(OrderRequests)
export default OrderRequests



// WEBPACK FOOTER //
// ./src/containers/admin/customer_orders.jsx